import {
    apiRequest,
    PNSlistPeriod
} from "../../../../../services/adapters/kepegawaian/PNSService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", PNSlistPeriod, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default DataTableRepository